import styled from 'styled-components'
import { limitLines } from 'src/styles'

const defaultHeight = '5.375rem' // 86px

export const Wrapper = styled.a`
  height: ${defaultHeight};
  transition: 0.2s background-color;

  &:hover {
    background-color: var(--gray-200) !important;
  }
`

Wrapper.displayName = 'Wrapper'

export const ImageWrapper = styled.div`
  width: ${defaultHeight};
  height: ${defaultHeight};

  img {
    object-fit: cover;
  }
`

ImageWrapper.displayName = 'ImageWrapper'

export const TextWrapper = styled.div``

TextWrapper.displayName = 'TextWrapper'

export const Title = styled.h2`
  ${limitLines(2)}
`

Title.displayName = 'Title'

export const Url = styled.span`
  ${limitLines(1)}
`

Url.displayName = 'Url'
